/* Belvoir free-gift countdown (Oct 2026).
   Drives every [data-bv-gift-timer] on the page, including ones the cart drawer
   re-renders, from one 1s interval. Times are UK time (Europe/London).
   Fills segment digits [data-bv-gt-seg="d|h|m|s"] and inline clocks [data-bv-gt-clock].
   Markup is server-rendered with "--" placeholders, so nothing moves when digits arrive.
   Rendered by snippets/bv-gift-timer.liquid; off unless Theme settings > Free gift timer is enabled.
   Performance: only writes text that actually changed, skips work while the tab is hidden,
   and sets the sticky-bar classes/vars only when their values change. */
(function () {
  if (window.__bvGiftTimer) return;
  window.__bvGiftTimer = true;

  var TZ = 'Europe/London';
  var fmtParts;
  try {
    fmtParts = new Intl.DateTimeFormat('en-GB', {
      timeZone: TZ, hourCycle: 'h23', year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit'
    });
  } catch (e) { return; }

  function londonParts(d) {
    var o = {};
    fmtParts.formatToParts(d).forEach(function (p) { o[p.type] = p.value; });
    return o;
  }

  /* ms difference between UK wall-clock and UTC at instant d (0 in winter, 1h in summer) */
  function londonOffset(d) {
    var p = londonParts(d);
    var asUtc = Date.UTC(+p.year, +p.month - 1, +p.day, +p.hour % 24, +p.minute, +p.second);
    return asUtc - Math.floor(d.getTime() / 1000) * 1000;
  }

  var endCache = {};
  function fixedEnd(str) {
    if (endCache.hasOwnProperty(str)) return endCache[str];
    var m = /^\s*(\d{4})-(\d{1,2})-(\d{1,2})(?:[ T]+(\d{1,2}):(\d{2}))?/.exec(str || '');
    var v = null;
    if (m) {
      var wall = Date.UTC(+m[1], +m[2] - 1, +m[3], m[4] ? +m[4] : 23, m[5] ? +m[5] : 59);
      v = wall - londonOffset(new Date(wall));
    }
    endCache[str] = v;
    return v;
  }

  function msLeft(el, now) {
    if (el.getAttribute('data-mode') === 'fixed') {
      var end = fixedEnd(el.getAttribute('data-end'));
      return end === null ? -1 : end - now.getTime();
    }
    /* daily: count down to the next reset time, UK time (default 00:00) */
    var r = /^\s*(\d{1,2}):(\d{2})/.exec(el.getAttribute('data-reset') || '');
    var rh = r ? Math.min(+r[1], 23) : 0;
    var rm = r ? Math.min(+r[2], 59) : 0;
    var p = londonParts(now);
    var nowSec = (+p.hour % 24) * 3600 + (+p.minute) * 60 + (+p.second);
    var left = rh * 3600 + rm * 60 - nowSec;
    if (left <= 0) left += 86400;
    return left * 1000;
  }

  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function parts(ms) {
    var s = Math.max(0, Math.floor(ms / 1000));
    var d = Math.floor(s / 86400); s -= d * 86400;
    var h = Math.floor(s / 3600); s -= h * 3600;
    var m = Math.floor(s / 60); s -= m * 60;
    return { d: d, h: h, m: m, s: s };
  }

  function inline(t) {
    return (t.d ? t.d + 'd ' : '') + pad(t.h) + ':' + pad(t.m) + ':' + pad(t.s);
  }

  /* {threshold}: shown exactly as the mystery gift enforces it. mystery-gift.js compares the
     cart total in the shopper's currency against the raw setting number (no exchange rate),
     so 49 means £49 in the UK, €49 in the EU, $49 in the US. Per-market amounts come from
     market-specific theme settings (e.g. config/settings_data.context.us.json). */
  function money(amount) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
        style: 'currency', currency: cur, minimumFractionDigits: 0, maximumFractionDigits: 2
      }).format(amount);
    } catch (e) { return cur + ' ' + amount; }
  }

  function setText(node, txt) { if (node.textContent !== txt) node.textContent = txt; }

  function tick() {
    if (document.hidden) return;
    var now = new Date();
    var els = document.querySelectorAll('[data-bv-gift-timer]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var left = msLeft(el, now);
      if (left <= 0) { if (!el.hidden) el.hidden = true; continue; }
      var t = parts(left);

      var segs = el.querySelectorAll('[data-bv-gt-seg]');
      var hasDays = !!el.querySelector('[data-bv-gt-seg="d"]');
      for (var j = 0; j < segs.length; j++) {
        var u = segs[j].getAttribute('data-bv-gt-seg');
        var v = u === 'd' ? t.d : u === 'h' ? (hasDays ? t.h : t.h + t.d * 24) : u === 'm' ? t.m : t.s;
        setText(segs[j], pad(v));
      }

      var clocks = el.querySelectorAll('[data-bv-gt-clock]');
      for (var k = 0; k < clocks.length; k++) setText(clocks[k], inline(t));

      if (!el.hasAttribute('data-ready')) {
        var th = parseFloat(el.getAttribute('data-threshold')) || 0;
        var spots = el.querySelectorAll('[data-bv-gt-threshold]');
        for (var x = 0; x < spots.length; x++) spots[x].textContent = th > 0 ? money(th) : '';
        el.setAttribute('data-ready', '');
      }
    }
  }

  /* sticky bar: mark it with plain classes (no :has() in CSS) and publish the bar's and the
     header's real heights so they stack with no gap. Only writes when a value changes. */
  var lastBarH = -1, lastHdrH = -1;
  function syncBar() {
    var s = document.querySelector('.bv-gt-bar-section');
    var hdr = document.querySelector('.section-header');
    var sticky = !!(s && s.querySelector('.bv-gt-bar--sticky'));
    var root = document.documentElement;
    if (s) s.classList.toggle('bv-gt-is-sticky', sticky);
    root.classList.toggle('bv-gt-sticky-bar', sticky);
    var h = sticky ? Math.round(s.getBoundingClientRect().height * 100) / 100 : 0;
    if (h !== lastBarH) { lastBarH = h; root.style.setProperty('--bv-gt-bar-h', h + 'px'); }
    if (hdr) {
      var hh = Math.round(hdr.getBoundingClientRect().height * 100) / 100;
      if (hh !== lastHdrH) { lastHdrH = hh; root.style.setProperty('--bv-gt-header-h', hh + 'px'); }
    }
  }
  function initBar() {
    var barSection = document.querySelector('.bv-gt-bar-section');
    if (!barSection) return;
    syncBar();
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(syncBar);
      ro.observe(barSection);
      var hdrSection = document.querySelector('.section-header');
      if (hdrSection) ro.observe(hdrSection);
    } else {
      window.addEventListener('resize', syncBar);
    }
  }

  function start() { initBar(); tick(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  setInterval(tick, 1000);
  document.addEventListener('visibilitychange', tick);
})();
